import { Component, EventEmitter, Input, Output } from '@angular/core';
import { TopicvizService } from '@services/topicviz/topicviz.service';

@Component({
  selector: 'app-sync-ideas',
  templateUrl: './sync-ideas.component.html',
  styleUrls: ['./sync-ideas.component.scss'],
})
export class SyncIdeasComponent {
  @Input() requestInProgress;
  @Output() requestInProgressChange = new EventEmitter<boolean>();

  public options = {
    keywordExtractionAlgorithm: 'TEXTRANK',
    n_keywords: 3,
    find_pictures: true,
  };
  constructor(private topicVizDataLoader: TopicvizService) {}

  syncIdeas() {
    this.requestInProgressChange.emit(true);
    this.topicVizDataLoader
      .syncIdeas(
        this.options['keywordExtractionAlgorithm'],
        this.options['n_keywords'],
      )
      .subscribe(
        () => {
          this.requestInProgressChange.emit(false);
        },
        response => {
          this.requestInProgressChange.emit(false);
          alert(response['error']['message'] || 'Error while syncing ideas');
          console.error(response);
        },
      );
  }
}
